import PopupsManager from "react-sdk/PopupsManager"
import Catalogue from "./Catalogue"

import { makeAutoObservable } from "mobx"
import { POPUPS } from "../AppState"

class CatalogueItem {
  id
  parent
  titre
  description
  image

  locked=true

  /** Représente la maitrise de l'item
   * - -1 = non maitrisé
   * - 0 = pas encore vu dans activité
   * - 1 = maitrisé
   *  @type {-1 | 0 | 1} */
  knowledge = -1

  constructor(json) {
    Object.assign(this, json)
    makeAutoObservable(this)
  }

  get Children() {
    return Catalogue.all.filter(i => i.parent === this.id)
  }

  unlock(popupClosedCB) {
    this.locked = false

    this.Children.forEach(i => i.unlock())

    if(popupClosedCB) {
      PopupsManager.open(POPUPS.CATALOGUE_ITEM, [this], popupClosedCB)
    }
  }
}

export default CatalogueItem